'use client';

import { useEffect } from 'react';
import { CenteredLoadingSpinner } from '@bss-portfolio-view-ui/shared-common-ui-loading-spinner';
import { getWindow } from '@bss-portfolio-view-ui/shared-common-util-browser';
import { isPlaywrightEnvironment } from '@bss-portfolio-view-ui/shared-common-util-playwright';

export const Logout = () => {
  useEffect(() => {
    const window = getWindow();

    if (window) {
      setTimeout(
        () => {
          window.location.href = `/api/logout`;
        },
        // Hideous I know, but if the navigation happens too fast, the assertions about the logging out state fail in
        // Chromium.
        isPlaywrightEnvironment() ? 500 : 0,
      );
    }
  }, []);

  return <CenteredLoadingSpinner message="Logging out..." />;
};
